import styles from './NavigationButton.module.css';
import NextArrowWhite from '../../../../assets/icons/NextArrowWhite.svg';
import NextArrowBlack from '../../../../assets/icons/NextArrowBlack.svg';
import BackArrowBlack from '../../../../assets/icons/BackArrowBlack.svg';
import BackArrowWhite from '../../../../assets/icons/BackArrowBtn.svg';
import nextwithoutfill from '../../../../assets/icons/nextwithoutfill.svg';
import { Spin } from 'antd';

const BackButton = ({ onBack, text, width, isColorChanged, loading }) => (
  <button
    className={`${styles.backBtn} ${isColorChanged ? styles.backBtnColorChanged : ''}`}
    onClick={onBack}
    disabled={loading}
    style={{ width }}
  >
    {loading ? (
      <Spin size="small" />
    ) : (
      <>
        <img
          src={isColorChanged ? BackArrowWhite : BackArrowBlack}
          alt="back"
          className={styles.backIcon}
        />
        {text}
      </>
    )}
  </button>
);

const NextButton = ({ onNext, text, width, isDisabled, isColorChanged, showArrow = true , loading}) => (
  <button
    className={`${styles.nextBtn} ${!isDisabled ? styles.nextBtnActive : ''} ${
      isColorChanged ? styles.nextBtnColorChanged : ''
    }`}
    onClick={onNext}
    disabled={isDisabled || loading}
    style={{ width }}
  >
    {loading ? <Spin size="small" /> : text}

    {!loading && showArrow && (
      <span className={styles.nextIcon}>
        <img
          src={
            isDisabled
              ? nextwithoutfill
              : (isColorChanged ? NextArrowBlack : NextArrowWhite)
          }
          alt="next"
        />
      </span>
    )}
  </button>
);
const NavigationButton = ({
  onNext,
  onBack,
  nextText = 'Next',
  backText = 'Back',
  isNextDisabled = false,
  showBack = false,
  nextWidth = '200px',
  backWidth = '120px',
  isColorChanged = false,
  showNextArrow = true,
  nextLoading,
  backLoading,
  footerMaxWidth,
}) => (
  <div className={styles.footerWrap}>
    <div className={styles.footer} style={footerMaxWidth ? { maxWidth: footerMaxWidth } : undefined}>
      {showBack && (
        <BackButton
          onBack={onBack}
          text={backText}
          width={backWidth}
          isColorChanged={isColorChanged}
          loading={backLoading}
        />
      )}
      <NextButton
        onNext={onNext}
        text={nextText}
        width={nextWidth}
        isDisabled={isNextDisabled}
        isColorChanged={isColorChanged}
        showArrow={showNextArrow}
        loading={nextLoading}
      />
    </div>
  </div>
);

export default NavigationButton;
